// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","logo":"Footer_logo__1dEML","text":"Footer_text__Ws8Gy"};